import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface GenerateVitalRecordsReportRequest {
  fromDate: string;
  toDate: string;
}

export interface GenerateVitalRecordsReportResponse {
  token: string;
}

@Injectable({
  providedIn: 'root'
})
export class VitalReportService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Generate Vital Records Export
   * @param request Contains fromDate and toDate
   * @returns Observable with token
   */
  generateVitalRecordsExport(
    request: GenerateVitalRecordsReportRequest
  ): Observable<GenerateVitalRecordsReportResponse> {
    return this.httpClient.post<GenerateVitalRecordsReportResponse>(
      `${environment.apiUrl}/report/vital-records-report/generate-export`,
      request
    );
  }

  /**
   * Download Vital Records Export using token
   * @param token Token received from generate export
   * @returns Observable with file blob
   */
  downloadVitalRecordsExport(token: string): Observable<Blob> {
    return this.httpClient.get(
      `${environment.apiUrl}/report/vital-records-report/download-export?token=${token}`,
      { responseType: 'blob' }
    );
  }
}
